<section class="contactsection">
    <div class="contactheader">
        <strong>Contact Us</strong>
    </div>
    <div style="padding-left: 2%;">
        <strong class="help">Need Help with Your PBC Submission?</strong>
        <p class="parahelp">If you have questions about your submission, tracking status, or need assistance, our support team is here to help. All communications for PBC are handled via email. Before reaching out, please visit the MyODP website, where you’ll find helpful resources and answers to common questions.</p>
    </div>
    <hr >
    <div class="subsection">
        <div class="contactlist">
            <img class="iconImg" src="/assets/icons/contactshare.svg">
            <div class="list">
                <span class="contactsubtitle">How to Contact Us:</span>
                <ul>
                    <li>Email: <a [href]="'mailto:'+email">{{email}}</a></li>
                </ul>
            </div>
        </div>
        <div class="contactlist">
            <img class="iconImg" src="/assets/icons/pen.svg">
            <div class="list">
                <span class="contactsubtitle">What to Include in Your Email:</span>
                <ul>
                    <li>Your Agency name and contact information</li>
                    <li>MPI Number</li>
                    <li>Performance Measure code if applicable</li>
                    <li>A brief description of your question or issue</li>
                </ul>
            </div>
        </div>
        <div class="contactlist">
            <img class="iconImg" src="/assets/icons/time.svg">
            <div class="list">
                <span class="contactsubtitle">What to Expect:</span>
                <ul>
                    <li>ODP will review your inquiry and get back to you as soon as possible.</li>
                    <li>All replies will be sent to the email address you provide</li>
                </ul>
            </div>
        </div>
    </div>
    <hr>
    <span style="padding-left: 2%;" class="sectionend">Thank you for using HealthPerform<sup>TM</sup> PBC Data Submission Portal!</span>
</section>